import makeService from './api';

export default makeService('global_params');
